// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7173":"84599c3e","7346":"7104dc58","7412":"b93fc056","8351":"6b6705d5"}[chunkId] + ".chunk.css";
};